/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import {useUser} from '../../modules/newauth/UserContext'
import firebase from '../../firebase/FirebaseConfig'
import axios from 'axios'
import Swal from 'sweetalert2'
import {AddUserModal} from './component/AddUserModal'
import {UserDetailModal} from './component/UserDetailModal'

const UserManagementWrapper = () => {
  const {user} = useUser()
  const db = firebase.firestore()
  const [userData, setUserData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const [showMadalAddUser, setShowMadalAddUser] = useState(false)
  const [showMadalUserDetail, setShowMadalUserDetail] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [trigger, setTrigger] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    async function fetchData() {
      let data = []
      await db
        .collection('users')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            data.push({docId: doc.id, ...doc.data()})
          })
        })

      // Sort data by role
      data.sort((a, b) => {
        if (a.role === 'admin' && b.role !== 'admin') return -1
        if (a.role !== 'admin' && b.role === 'admin') return 1
        return 0
      })

      setUserData(data)
    }

    if (user) {
      fetchData()
    }
  }, [trigger])

  const columns = isMobile
    ? [
        {
          name: 'Email',
          selector: (row) => row.email,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{row.email}</p>
          },
        },
        {
          name: 'Role',
          selector: (row) => row.role,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{`${row.role}`}</p>
          },
        },
        {
          name: 'Action',
          selector: (row) => row.userId,
          sortable: true,
          cell: (row) => {
            return (
              <div className='btn btn-secondary btn-sm' onClick={() => handleMoreOptions(row)}>
                Options
              </div>
            )
          },
        },
      ]
    : [
        {
          name: 'Email',
          selector: (row) => row.email,
          sortable: true,
          cell: (row) => {
            return <p className='fs-7 fw-semibold'>{row.email}</p>
          },
        },
        {
          name: 'Name',
          selector: (row) => row.firstName + row.lastName,
          sortable: true,
          cell: (row) => {
            return (
              <>
                <div className='symbol symbol-30px me-3'>
                  <img src={row?.imageProfile} alt='' />
                </div>
                <p className='fs-5 fw-semibold mt-3'>{`${row.firstName} ${row.lastName}`}</p>
              </>
            )
          },
        },
        {
          name: 'Role',
          selector: (row) => row.role,
          sortable: true,
          cell: (row) => {
            return <p className='fw-semibold'>{`${row.role}`}</p>
          },
        },
        {
          name: 'User Id',
          selector: (row) => row.userId,
          sortable: true,
          cell: (row) => {
            return <p className='fs-8'>{row.userId}</p>
          },
        },
        {
          name: 'Malin Id',
          selector: (row) => row.userIdMalin1,
          sortable: true,
          cell: (row) => {
            return <p className='fs-8'>{row.userIdMalin1}</p>
          },
        },
        {
          name: 'Action',
          selector: (row) => row.userId,
          sortable: true,
          cell: (row) => {
            return (
              <div className='btn btn-danger btn-sm' onClick={() => handleDeleteUser(row.userId)}>
                Delete
              </div>
            )
          },
        },
      ]

  const filteredData = userData.filter(
    (user) =>
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.userId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.userIdMalin1?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const handleDeleteUser = async (userId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'This user will be permanently deleted!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    })

    if (!confirmResult.isConfirmed) return

    Swal.fire({
      title: 'Deleting...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    try {
      const apiUrl = `https://apiadmin-qsac5kr5gq-as.a.run.app/v1/users/delete/${userId}`
      const response = await axios.delete(apiUrl, {
        headers: {
          Authorization: `Bearer 4e98soIcO3oSAXmRch1S6dpEbSe6AoN6LmDZ4JhDlmzLfLp6N5`,
        },
      })

      if (response.data.status === 'success') {
        Swal.fire({
          title: 'Deleted!',
          text: 'User has been deleted.',
          icon: 'success',
          confirmButtonText: 'OK',
        })
        setTrigger(!trigger) // Refresh the data
      } else {
        Swal.fire({
          title: 'Error',
          text: response.data.message,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonText: 'OK',
      })
    }
  }

  const handleMoreOptions = (row) => {
    setSelectedUser(row)
    setShowMadalUserDetail(true)
  }

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder my-2'>
          User Management
          {/* <span className='fs-6 text-gray-400 fw-bold ms-1'>(59)</span> */}
        </h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Dashboard
              </Link>
            </li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
          {/* Search Input & Button */}
          <div className='d-flex gap-2'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-3 mb-1'>
                User Management ({filteredData?.length})
              </span>
            </h3>
          </div>

          {/* Search Input & Button */}
          {isMobile ? (
            <div className='d-flex flex-column flex-md-row gap-2 w-100'>
              <div className='input-group flex-grow-1  mt-3'>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div
                className='btn btn-primary w-100 w-md-auto mt-3'
                onClick={() => setShowMadalAddUser(true)}
              >
                Add new user
              </div>
            </div>
          ) : (
            <div className='d-flex gap-3'>
              <input
                type='text'
                className='form-control '
                placeholder='Search...'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{maxWidth: '200px'}} // Optional: จำกัดขนาดช่อง Search
              />

              <div className='my-2'>
                <div className='btn btn-sm btn-primary' onClick={() => setShowMadalAddUser(true)}>
                  Add new user
                </div>
              </div>
            </div>
          )}

          {/* <div className='d-flex gap-3'>
            <input
              type='text'
              className='form-control '
              placeholder='Search...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{maxWidth: '200px'}} // Optional: จำกัดขนาดช่อง Search
            />

            <div className='my-2'>
              <div className='btn btn-sm btn-primary' onClick={() => setShowMadalAddUser(true)}>
                Add new user
              </div>
            </div>
          </div> */}
        </div>
        <div className='card-body border-top py-3'>
          <div className='table-responsive' style={{borderRadius: '10px'}}>
            <DataTable
              columns={columns}
              data={Array.isArray(filteredData) ? filteredData : []}
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 100]}
              defaultSortFieldId='Email'
              defaultSortAsc={false}
            />
          </div>
        </div>
      </div>

      <AddUserModal
        showMadalAddUser={showMadalAddUser}
        setShowMadalAddUser={setShowMadalAddUser}
        trigger={trigger}
        setTrigger={setTrigger}
      />

      <UserDetailModal
        showMadalUserDetail={showMadalUserDetail}
        setShowMadalUserDetail={setShowMadalUserDetail}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        handleDeleteUser={handleDeleteUser}
      />
    </>
  )
}

export {UserManagementWrapper}
